<template>
  <button
    class="tw-h-[40px] tw-min-w-[189px] tw-px-4 tw-border tw-rounded-md tw-text-sm"
    :class="buttonStyles"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
const variants = {
  default: 'tw-border-[#402046] tw-bg-[#402046] tw-text-white ',
  outlined: 'tw-border-[#D1D5DB] tw-bg-white tw-text-black',
}

export default {
  props: {
    fullWidth: {
      default: false,
      type: Boolean,
    },
    variant: {
      default: 'default',
      type: String,
      validator: (variant) => Object.keys(variants).includes(variant),
    },
  },
  computed: {
    buttonStyles() {
      return [variants[this.variant], { 'tw-w-full': this.fullWidth }]
    },
  },
}
</script>
